module.exports = __webpack_public_path__ + "img/NextPlant.12cb9141.jpg";